import api from '../api'

export const fetchResponseList = async ({ content_pk }: { content_pk: string }) => {
  const res = await api.get(`/content/${content_pk}/responses/`, {
    params: {
      expand: 'employee',
    },
  })
  return res.data
}

export const fetchResponse = async ({ content_pk, response_id }: { content_pk: string; response_id: string }) => {
  const res = await api.get(`/content/${content_pk}/responses/${response_id}/`)
  return res.data
}

export const addContentResponse = async (
  content_pk: string,
  data: {
    answers: Array<{
      type: string
      question: string
      answer: number | string | number[] | boolean | null
    }>
  },
) => {

  const formattedData = {
    answers: data.answers.map((answer) => {
      if (answer.answer === null) {
        return { ...answer, answer: '' }
      }
      return answer
    }),
  }

  const res = await api.post(`/content/${content_pk}/responses/`, formattedData)
  return res.data
}
